import { useContext } from 'react';
import AppMainConfigContext from '../AppMainConfigContext';

export default function useAppMainConfig() {
  return useContext(AppMainConfigContext);
}
